export default "assets/linkedin-big-002ac260.svg";